import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Notifications"],
  endpoints: (builder) => ({
    getNotifications: builder.query({
      providesTags: ["Notifications"],
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: "/notification",
        method: "GET",
        params: { page, limit },
      }),
    }),
    markNotificationAsRead: builder.mutation({
      query: (id) => ({
        url: `/notification/markread`,
        method: "PATCH",
        body: id ? { id } : {},
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
} = notificationApi;
